import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import axios from "axios";


interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    isEng: boolean;
}

interface State {
  

}
export class BusinessNumberComponent extends React.Component<Props, State> {
   
  
    constructor(props: Props) {
        super(props);

        let field = this.props.field;
        FormValidationUtils.runJavascript(field);
    }
    
    valueLength(value) {
      if (typeof value == 'string') {
        return value.length;
      }
      return 0;
    }

    render() {
        let field =  this.props.field;
  
        let  editable = this.props.editable;
        let labelControlArray =this.props.labelControlArray;
        let requiredField =this.props.requiredField;
        let controlArray = [];
        let title = this.props.title;
    
        if (editable) {
          controlArray.push(
            <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}>

              <div key={'fdLbl_div_' + field.Id} >
                {labelControlArray}
              </div>
              <div>
              <LiveValidationErrMsg
                             field={this.props.field}
                            isEng={this.props.isEng}
                            key={"LiveValidationErrMsg_" +this.props.field.LoadBindName} />

              </div>
              <div key={'fdIpt_div_' + field.Id} >
                <div>
                  <input className={this.props.field.Valid || !this.props.field.Touched?'ontario-input form-input-width-medium':'ontario-input ontario-input__error'} id={field.LoadBindName}  key={'fdIpt_' + field.Id} 
                  required={requiredField} value={field.Value} readOnly={field.ReadOnly}
                    onChange={(e) => {
                      let val = e.target.value;
                      field.Value = val==null?null: val.toUpperCase();  
                     
                      FormValidationUtils.validateBusinessNumber(field)

                      FormValidationUtils.runJavascript(field);
                      if(field.Valid){
                      
                        const url = process.env.TPON_BD_URL.replace("{{bn9}}", field.Value).replace("{{ownership}}", "Corporation").replace("{{language}}", this.props.isEng?"en":"fr");
               
                        let postObject = {
                          url: url,
                          httpMethod: "GET",
                          payload: null
                      };
                     axios.post(process.env.LAYOUT_API_URL + "/tponTransfer", postObject)
                     .then(response => {
                         console.log(response.data);
                        })
                        .catch(error => {
                          console.error('Error:', error);
                        });
                      }

                      this.props.callbackElement(this.props.field.parent.parent.parent);
                    }
                    } />
                </div>
              </div>
            </div>);
        } else {
          controlArray.push(
            <div className='pdf-two-column'>
              <div>{title}</div>
              <div className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >{this.props.field.Value}</div>
            </div>
          );
        }

        return controlArray;
    }

}